import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getSimCardsRequest, getHistorySimcardsRequest, getSimcardsSubstatusesRequest, patchSimcardsBatchRequest, setSimcardSelected } from '../../actions/simcards';
import { getGpsDevicesRequest } from '../../actions/gps';
import { simCardSelector } from '../../selectors/simcards';
import { gpsSelector } from '../../selectors/gps';
import SimcardDetail from './SimcardDetail';

const mapStateToProps = createStructuredSelector({
    simcards: simCardSelector,
    gps: gpsSelector
});

const mapDispatchToProps = {
    getSimCardsRequest,
    getHistorySimcardsRequest,
    getGpsDevicesRequest,
    getSimcardsSubstatusesRequest,
    patchSimcardsBatchRequest,
    setSimcardSelected
};

export default connect(mapStateToProps, mapDispatchToProps)(SimcardDetail);